const allToneAttributes = {
    number: "1/5",
    question: "Tone of Voice",
    description: `Now think what that person would sound like if they
                                approached you, shook your hand, and started a conversation?
                                If it was a bar, how would you describe the music that is playing?
                                - Only use adjectives that describe a tone of voice, and not visuals.`
}

const fiveToneAttributes = {
    number: "2/5",
    question: "Tone of Voice",
    description: "Pick the top 5 attributes"
}

const threeToneAttributes = {
    number: "3/5",
    question: "Tone of Voice",
    description: "Pick the top 3 attributes"
}

const companiesThatSoundLikeThat = {
    number: "4/5",
    question: "Tone of Voice",
    description: "List companies that sound like that"
}

const peopleThatSoundLikeThat = {
    number: "5/5",
    question: "Tone of Voice",
    description: "List brands or celebrities that you love how they communicate"
}

export const questions = {
    allToneAttributes: allToneAttributes,
    fiveToneAttributes: fiveToneAttributes,
    threeToneAttributes: threeToneAttributes,
    companiesThatSoundLikeThat: companiesThatSoundLikeThat,
    peopleThatSoundLikeThat: peopleThatSoundLikeThat,
}

const allToneAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/pfakteodiwp6cqqt9t2xm/24-Tone-of-Voice.mp4?rlkey=pxh1td35cp6i1ux4dp1mrt04w&raw=1"
}

const fiveToneAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/pfakteodiwp6cqqt9t2xm/24-Tone-of-Voice.mp4?rlkey=pxh1td35cp6i1ux4dp1mrt04w&raw=1"
}

const threeToneAttributesVideo = {
    url: "https://www.dropbox.com/scl/fi/23jdjkzieanpr90vqlfca/25-Tone-of-voice-filter.mp4?rlkey=2mfzby10lsay0c6934lkbhv9n&raw=1"
}

export const videos = {
    allToneAttributesVideo: allToneAttributesVideo,
    fiveToneAttributesVideo: fiveToneAttributesVideo,
    threeToneAttributesVideo: threeToneAttributesVideo
}